// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"clinical-portal-3__Dropdown__dropdown"};